<template>
  <VLayout column>
    <Header/>
    <PayFormPaywith/>
    <Footer/>
  </VLayout>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import PayFormPaywith from '@/components/PayFormPaywith.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'UserLanding',
  components: {
    Header,
    PayFormPaywith,
    Footer,
  },
};
</script>
